export default "__VITE_PUBLIC_ASSET__436db707__"